import { TableCell } from "@mui/material";
import Button from "../../../Components/Button";
import {
  IAddEditRoleFormValues,
  IRolesTableReport,
} from "../../../Interfaces/roleAndPermissionsInterfaces";
import { IAdditional } from "../../TableTemplate/tableTemplate";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Tooltip } from "@mui/material";
import { useContext, useState } from "react";
import { RolesTableContext } from "./Table";
import Modal from "../../../Components/Modal/Modal";
import { deleteRole } from "../../../Requests/roleAndPermissionsRequests";
import { toast } from "react-toastify";
import { packetErrorHandler } from "../../../Utils/requestUtils";

const RolesTableAdditionalHeader = () => {
  return (
    <TableCell>
      <span className="!font-black text-black">عملیات</span>
    </TableCell>
  );
};

const RolesTableAdditionalCol: React.FC<{
  row: IRolesTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const onEdit = useContext(RolesTableContext).onEdit;
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const editClickHandler = () => {
    onEdit({
      roleId: row.id,
      permissionIds: row.permissionIds,
      roleName: row.name,
      isPrivate: row.isPrivate,
    } as IAddEditRoleFormValues);
  };

  const deleteClickHandler = () => {
    setIsDeleting(true);
    deleteRole(row.id)
      .then((response) => {
        if (!response.data) {
          toast.error(response.msg);
          return;
        }

        toast.success(response.msg);
        setIsDeleteOpen(false);
        onAction();
      })
      .catch(packetErrorHandler)
      .finally(() => setIsDeleting(false));
  };

  return (
    <TableCell>
      {isDeleteOpen ? (
        <Modal
          onClose={() => setIsDeleteOpen(false)}
          modalBoxClassName="compact-confirm-modal"
          UI={
            <div
              dir="rtl"
              className="w-full flex flex-col gap-6 items-stretch text-right"
            >
              <div className="flex flex-col gap-2">
                <div className="text-base font-bold text-slate-800">
                  حذف نقش
                </div>
                <div className="text-sm leading-6 text-slate-600">
                  آیا از حذف نقش «{row.name}» مطمئن هستید؟ نقش اختصاص‌یافته
                  به کاربران قابل حذف نیست.
                </div>
              </div>
              <div className="flex flex-row gap-2 w-full">
                <Button
                  text="انصراف"
                  variant="outlined"
                  onClick={() => setIsDeleteOpen(false)}
                />
                <Button
                  text="حذف نقش"
                  variant="contained"
                  onClick={deleteClickHandler}
                  loading={isDeleting}
                />
              </div>
            </div>
          }
        />
      ) : null}
      <div className="flex flex-row gap-2 w-min">
        <Tooltip title="ویرایش" arrow>
          <Button
            onClick={editClickHandler}
            text={<EditIcon className="!text-sm" />}
            variant="contained"
            className="table-btn"
          />
        </Tooltip>
        <Tooltip title="حذف" arrow>
          <Button
            onClick={() => setIsDeleteOpen(true)}
            text={<DeleteIcon className="!text-sm" />}
            variant="contained"
            className="table-btn"
          />
        </Tooltip>
      </div>
    </TableCell>
  );
};

export const RolesTableAdditional: IAdditional<IRolesTableReport> = {
  getHeader: RolesTableAdditionalHeader,
  getRow: RolesTableAdditionalCol,
};
